import { defineMessages } from 'react-intl';

import { IntlErrorMessageIdentifier } from '../../types/ApiErrorCodes';

// In case if for this particular mutation, the different set of messages needs to be defined
// for the particular place, it must be done exactly in the same way:
// define new enum and new messages here and use wherever those are needed.

// This is only one of the possible errors
enum ErrorMessagesIds {
  productIsOutOfStock
  = 'productIsOutOfStock',
}

export type MessageDefiner = IntlErrorMessageIdentifier & {
  intlMessageId: ErrorMessagesIds;
};

export const messageDefiner: MessageDefiner[] = [{
  referencedRequestParameter: '',
  code: 2031,
  intlMessageId: ErrorMessagesIds.productIsOutOfStock,
}];

export const errorMessages = defineMessages<ErrorMessagesIds>({
  [ErrorMessagesIds.productIsOutOfStock]: {
    id: 'src.constants.AddOriginalPackageToCartAndPlaceOrderMutationsErrorMessages.productIsOutOfStock',
    defaultMessage: 'Not possible to continue with this gift card because currently it is out the stock.',
  },
});
